import { premiumCoupon } from './../../domain/extra/extra.reducer';
import {
  CompletePaymentIntent,
  CouponState,
  MyPremium,
  MyPremiumModuleElement,
  MyPremiumState,
  PaymentConfirmation,
  PremiumDiscountType
} from './../../domain/extra/extra.model';
import { loadStripe, PaymentIntent } from '@stripe/stripe-js';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  effect,
  input,
  output
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { filter, Observable, Subscription, tap } from 'rxjs';
import { LogService } from '../../core/log/log.service';
import {
  PremiumModuleElement,
  PremiumSubscription,
  PremiumTokenError
} from '../../domain/extra/extra.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CodiceScontoForm, CouponForm, SellerForm } from './payment-form.model';
import { UserDTO } from '../../domain/user/user.model';
import { EnvironmentService } from '../../../environments/environment.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';

// declare var Stripe: any;

@Component({
  selector: 'dottnet-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['./payment-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatSelectModule, MatOptionModule, MatCheckboxModule, MatTabsModule, TranslateModule]
})
export class PaymentFormComponent implements OnInit, AfterViewInit, OnDestroy {
  // userObservable may be undefined to show form in signing up mode (blank and with some extra fields)

  readonly paymentIntentSignal = input<CompletePaymentIntent | undefined>(undefined);
  readonly paymentSuccess = input<boolean>(false);
  readonly premiumModules = input<PremiumModuleElement[]>([]);
  readonly discountTypeList = input<PremiumDiscountType[]>([]);
  readonly tokenError = input<PremiumTokenError | undefined>(undefined);
  readonly myPremium = input<MyPremiumState | undefined>(undefined);
  readonly coupon = input<CouponState | undefined>(undefined);
  readonly user = input<UserDTO | undefined>(undefined);
  readonly sessionId = input<number | undefined>(undefined);

  readonly submitUpdateSubscription = output<{
    module: MyPremiumModuleElement;
    stripeId: string;
    userId: number;
}>();
  readonly submitIntentSubscription = output<PremiumSubscription>();
  readonly submitConfirmCardPayment = output<PaymentConfirmation>();
  readonly submitCheckTokenForm = output<string>();
  readonly submitSubscription = output<string>();
  readonly submitLoadUserPremium = output<number>();
  readonly submitCouponGeneration = output<{
    idTipoSconto: number;
    idAnagrafica: number;
}>();

  subscriptionDuration: string;
  // Main form group
  codicescontoForm: FormGroup<CodiceScontoForm>;
  sellerForm: FormGroup<SellerForm>;
  couponForm: FormGroup<CouponForm>;
  subList: Subscription[] = [];
  fatturaChecked: boolean = false;
  premiumfineabbonamento: string;
  isAbbonatoPremium: boolean = false;
  enableTokenButton: boolean = false;
  enableCouponButton: boolean = false;
  enableCaricaAnagrafica: boolean = false;
  loadedUser: boolean = false;
  tokenEmitted: boolean = false;
  errorToken: boolean = false;
  showPayment: boolean = false;
  isProcess: boolean = false;
  isPagare: boolean = true;
  codice_errore_sconto: number = 0;
  prorate: number = 0;
  messaggio_errore_sconto: string;
  piva = new FormControl('', [Validators.required]);
  pec = new FormControl('', [Validators.required]);
  sd = new FormControl('', [Validators.required]);

  name = new FormControl('', [Validators.required]);
  email = new FormControl('', [Validators.required]);
  sfNome = new FormControl('');
  sfCognome = new FormControl('');
  sfEmail = new FormControl('');
  sfPremium = new FormControl('');
  sfInizioAbbonamento = new FormControl('');
  sfFineAbbonamento = new FormControl('');
  tipoSconto = new FormControl('');

  statoAbbonamento: MyPremium;
  myPremiumModules: MyPremiumModuleElement[];

  labelDeleteSubscription: string;
  tokenCodice: string = '';
  totaleDaPagare: number = 0.0;
  totaleDaPagareProdotti: number = 0.0;
  totaleDaPagareServizi: number = 0.0;
  totaleDaPagareProrate: number = 0.0;
  totaleDaPagareProrateS: number = 0.0;
  totaleCoupon: number = 0.0;
  listaIdModulo: number[] = [];
  listaIdTipoSconto: number[] = [];
  listaIdTipoAbbonamento: number[] = [];
  listaProdotti: number[] = [];
  listaPrezzi: number[] = [];
  paymentIntent: string;
  stripeId: string;
  sessionID: number;
  paymentStatus: string;


  clientSecret: string
  constructor(
    private logService: LogService,
    private fb: FormBuilder,
    private store: Store,
    private translate: TranslateService,
    private changeDetectorRef: ChangeDetectorRef,
    private environmentService: EnvironmentService
  ) {
    //effect per gestire i cambiamenti dei signal

    effect(() => {
      const paymentIntent = this.paymentIntentSignal();
      if (!!paymentIntent) {
        this.logService.info('paymentIntent: ', paymentIntent);
        this.stripeId = paymentIntent.stripeId;
        this.paymentStatus = paymentIntent.paymentIntent.status;
        // se ho un paymentIntent allora devo mostrare il form di pagamento

        switch (this.paymentStatus) {
          // il tentativo di pagamento è stato effettuato me richiede una azione  (es. 3D secure)
          case 'requires_action':
            this.stripeHandleCardAction(paymentIntent.paymentIntent);
            break;
          default:
            // mostro la form di pagamento
            if (paymentIntent.paymentIntent) {
              this.paymentIntent = paymentIntent.paymentIntent.id;
              this.clientSecret = paymentIntent.paymentIntent.client_secret;
              this.showPayment = true;
            }
            // in alternativa vuol dire che non c'era nulla dapagare perchè l'abbonamento era gratuito e non devo mostrare la form di pagamento
            // ma devo procedere con la sola conferma
            else {
              this.submitSubscription.emit(this.stripeId);
            }
        }
      }
    });

    effect(() => {
      const myPremium = this.myPremium();
      if (myPremium && !!myPremium.premiumState) {
        this.premiumfineabbonamento = myPremium.premiumState.endSubscription;
        this.loadedUser = true;

        this.sfNome.setValue(myPremium.premiumState.name);
        this.sfCognome.setValue(myPremium.premiumState.surname);
        this.sfEmail.setValue(myPremium.premiumState.email);
        this.sfPremium.setValue(
          myPremium.premiumState.premium
            ? this.translate.instant('dottnet.extra.sellerAbbonato')
            : this.translate.instant('dottnet.extra.sellerNonAbbonato')
        );
        this.sfInizioAbbonamento.setValue(myPremium.premiumState.startSubscription);
        this.sfFineAbbonamento.setValue(myPremium.premiumState.endSubscription);

        this.statoAbbonamento = myPremium.premiumState;
        this.myPremiumModules = myPremium.myModules;
        // this.changeDetectorRef.detectChanges();
      }
    });

    effect(() => {
      const modules = this.premiumModules();
      if (modules && modules.length > 0) {
        this.logService.info('premiumModules: ', modules);
        // mi sono arrivati moduli nuovi ... quindi resetto il totale e tutte le liste
        this.totaleDaPagare = 0.0;
        this.isPagare = true;
        modules.forEach((module) => {
          if (module.activeCampaign === 2 && !module.mandatory) {
            this.totaleDaPagare = this.totaleDaPagare + module.priceDiscounted;
          }

          if (module.mandatory) {
            this.addModuleInfo(module);
          }
        });
      }
    });


    effect(() => {
      const paymentSuccess = this.paymentSuccess();
      if (paymentSuccess === true) {
        // resetto tutto
        this.isProcess = false;
        this.showPayment = false;
        this.totaleDaPagare = 0.0;
        this.totaleDaPagareProdotti = 0.0;
        this.totaleDaPagareServizi = 0.0;
        this.totaleDaPagareProrate = 0.0;
        this.totaleDaPagareProrateS = 0.0;
        this.listaIdModulo = [];
        this.listaIdTipoSconto = [];
        this.listaIdTipoAbbonamento = [];
        this.listaProdotti = [];
        this.listaPrezzi = [];
      }
    });


    effect(() => {
      const coupon = this.coupon();
      if (!!coupon) {
        this.logService.info('COUPON: ', coupon);
        this.codicescontoForm.controls.token.setValue(coupon.randomString);
        this.enableTokenButton = true;
      }
    });

    effect(() => {
      const sessionId = this.sessionId();
      if (!!sessionId) {
        this.sessionID = sessionId;
      }

    });
  }

  ngOnInit() {
    this.codicescontoForm = this.fb.group<CodiceScontoForm>({
      token: new FormControl<string | null>('', {})
    });
    this.couponForm = this.fb.group({
      idTipoSconto: new FormControl<number | null>(0, {})
    });

    const user = this.user();
    if (user) {
      this.isAbbonatoPremium = user.premium;
    }


    this.sellerForm = this.fb.group<SellerForm>({
      sfIdAnagrafica: new FormControl(null, {}),
      sfNome: new FormControl({ value: '', disabled: true }),
      sfCognome: new FormControl({ value: '', disabled: true }),
      sfEmail: new FormControl({ value: '', disabled: true }),
      sfPremium: new FormControl({ value: '', disabled: true }),
      sfInizioAbbonamento: new FormControl({ value: '', disabled: true }),
      sfFineAbbonamento: new FormControl({ value: '', disabled: true })
    });
  }

  ngAfterViewInit(): void {

    this.stripeMethods();
  }

  ngOnDestroy(): void {
    this.subList.forEach((sub) => sub.unsubscribe());
  }

  setFatturaChecked() {
    this.fatturaChecked = !this.fatturaChecked;
  }

  getDuration(duration: number, product: boolean) {
    let subscriptionDuration: string;
    switch (duration) {
      case 3:
        subscriptionDuration = this.translate.instant('dottnet.extra.duration_3');
        break;
      case 6:
        subscriptionDuration = this.translate.instant('dottnet.extra.duration_6');
        break;
      case 9:
        subscriptionDuration = this.translate.instant('dottnet.extra.duration_9');
        break;
      case 12:
        subscriptionDuration = this.translate.instant('dottnet.extra.duration_12');
        break;
      case 24:
        subscriptionDuration = this.translate.instant('dottnet.extra.duration_24');
        break;
      default:
        subscriptionDuration =
          '/ ' + duration + this.translate.instant('dottnet.extra.duration_default');
        break;
    }
    if (product) {
      subscriptionDuration = '';
    }

    return subscriptionDuration;
  }

  showFormPagamento() {
    const user = this.user();
    this.name.setValue(
      !user.isSellerExtra
        ? user.nome + ' ' + user.cognome
        : this.sfNome.value + ' ' + this.sfCognome.value
    );
    this.email.setValue(!user.isSellerExtra ? user.email : this.sfEmail.value);

    const subscriptionData: PremiumSubscription = {
      // tokenId: result.token.id,
      totaleCoupon: this.totaleCoupon,
      totaleDaPagare: this.totaleDaPagareProrate * 100, // stripe ragiona in centesimi.. quindi mando il prezzo intero e poi divido lato server
      tokenCodice: this.tokenCodice,
      listaIdModulo: this.listaIdModulo,
      listaIdTipoSconto: this.listaIdTipoSconto,
      listaIdTipoAbbonamento: this.listaIdTipoAbbonamento,
      listaProdotti: this.listaProdotti,
      listaPrezzi: this.listaPrezzi,
      piva: this.piva.value,
      pec: this.pec.value,
      sd: this.sd.value,
      idAnagrafica: user.idAnagrafica,
      nome: user.nome,
      cognome: user.cognome,
      email: user.email,
      stripeId: user.stripeId,
      sessionId: this.sessionID
    };
    // emetto un evento per far si che il container dispatchi una chiamata al server
    // per la creazione del payment intent e inserimento dei moduli premium
    this.submitIntentSubscription.emit(subscriptionData);

  }

  updateextra(myModule: MyPremiumModuleElement) {
    this.logService.info('myModule to emit: ', myModule);
    this.submitUpdateSubscription.emit({ module: myModule, stripeId: this.user().stripeId, userId: this.user().idAnagrafica });
  }

  generacodicesconto() {
    this.logService.info('generacodicesconto : ', this.couponForm.controls.idTipoSconto.value);
    // genero codice sconto
    this.submitCouponGeneration.emit({
      idTipoSconto: this.couponForm.controls.idTipoSconto.value,
      idAnagrafica: this.sellerForm.value.sfIdAnagrafica
    });
  }

  tokenChanged() {
    if (this.codicescontoForm.value.token.length > 0) {
      this.logService.info('Token Changed: ', this.codicescontoForm.value.token);
      this.enableTokenButton = true;
    } else {
      this.logService.info('Emitted: ', this.tokenEmitted);
      this.enableTokenButton = false;
      // se ho già messo un token al container, allora devo richiedere i pacchetti,
      // se invece ho solo scritto e cancellato, non necessito di chiederli di nuovo, perchè non li ho mai sostituiti
      if (this.tokenEmitted) {
        this.tokenCodice = '';
        this.submitCheckTokenForm.emit(this.codicescontoForm.value.token);
      }
    }
  }

  couponSelected(event) {
    this.logService.info('couponSelected : ', event.value);
    this.couponForm.controls.idTipoSconto.setValue(event.value);
    if (event.value > 0) {
      this.enableCouponButton = true;
    } else {
      this.enableCouponButton = false;
    }
  }

  sfIdAnagraficaChanged() {
    if (this.sellerForm.value.sfIdAnagrafica > 0) {
      this.enableCaricaAnagrafica = true;
    }
  }

  applicaSconto() {
    // quando applico uno sconto, devo resettare il totale da pagare e le liste, perchè saranno sostituite da quelle dello sconto emesso
    this.totaleDaPagare = 0.0;
    this.totaleDaPagareProdotti = 0.0;
    this.totaleDaPagareServizi = 0.0;
    this.totaleDaPagareProrate = 0.0;
    this.totaleDaPagareProrateS = 0.0;
    this.listaIdModulo = [];
    this.listaIdTipoSconto = [];
    this.listaIdTipoAbbonamento = [];
    this.listaProdotti = [];
    this.listaPrezzi = [];

    this.logService.info('ApplicaSconto ', this.codicescontoForm);
    this.submitCheckTokenForm.emit(this.codicescontoForm.value.token);
    this.tokenCodice = this.codicescontoForm.value.token;
    // mi setto una variabile che mi dice che il token è stato emesso al container
    this.tokenEmitted = true;
  }

  updateData(module: PremiumModuleElement, checked: Event) {
    if (checked) {
      this.addModuleInfo(module);
    } else {
      this.removeModuleInfo(module);
    }
  }

  prorateCalculation(servizi: number, prodotti: number) {
    // devo calcolare correttamente il totale da pagare e dipende se sono già un abbonato o no
    // se sono abbonato allora devo applicare il prorate sul totale dei servizi (i prodotti no)
    // se non sono abbonato allora vuol dire che sto in fase di creazione di una sottoscrizione ed il totale corrisponde alla somma dei totali

    // APPLICO LA FORMULA DEL PRORATE SOLO SUL TOTALE SERVIZI
    const unixtimefineabbonamento: number =
      Date.parse(new Date(this.user().dataFineAbbonamento).toISOString()) / 1000;
    const unixtimeinizioabbonamento: number =
      Date.parse(new Date(this.user().dataInizioAbbonamento).toISOString()) / 1000;
    const unixtimeprorationabbonamento = Math.floor(Date.now() / 1000);

    const prorate =
      (servizi * (unixtimefineabbonamento - unixtimeprorationabbonamento)) /
      (unixtimefineabbonamento - unixtimeinizioabbonamento);

    if (prorate > 0) {
      this.totaleDaPagareProrateS = prorate;
      this.totaleDaPagareProrate = prodotti + this.totaleDaPagareProrateS;
      this.totaleDaPagareProrate = parseFloat(this.totaleDaPagareProrate.toFixed(2));
    } else {
      // SE IL TOTALE PRORATO E' ZERO (OVVERO NON CI SONO SERVIZI FLAGGATI), ALLORA PER IL TOTALE PRORATE DA MOSTRARE NELLA FORM
      // PRENDO LA SOMMA TRA IL TOTALE PRODOTTI E IL TOTALE DEI SERVIZI (CHE SARA' 0)
      this.totaleDaPagareProrate = prodotti + servizi;
    }
    this.totaleDaPagare = prodotti + servizi;
  }

  addModuleInfo(module: PremiumModuleElement) {
    if (module.product) {
      this.totaleDaPagareProdotti = this.totaleDaPagareProdotti + module.priceDiscounted;
    } else {
      this.totaleDaPagareServizi = this.totaleDaPagareServizi + module.priceDiscounted;
    }

    // devo calcolare correttamente il totale da pagare e dipende se sono già un abbonato o no
    if (this.isAbbonatoPremium) {
      this.prorateCalculation(this.totaleDaPagareServizi, this.totaleDaPagareProdotti);
    } else {
      this.totaleDaPagare = this.totaleDaPagare + module.priceDiscounted;
      this.totaleDaPagareProrate = this.totaleDaPagare;
      this.totaleDaPagareProrate = parseFloat(this.totaleDaPagareProrate.toFixed(2));
    }

    this.totaleCoupon = this.totaleCoupon + (module.price - module.priceDiscounted);
    this.listaIdModulo.push(module.moduleId);
    this.listaIdTipoSconto.push(module.discountTypeId);
    this.listaIdTipoAbbonamento.push(module.subscriptionTypeId);
    this.listaPrezzi.push(module.priceDiscounted);

    if (module.product) {
      this.listaProdotti.push(module.moduleId);
    }
  }

  removeModuleInfo(module: PremiumModuleElement) {
    if (module.product) {
      this.totaleDaPagareProdotti = this.totaleDaPagareProdotti - module.priceDiscounted;
    } else {
      this.totaleDaPagareServizi = this.totaleDaPagareServizi - module.priceDiscounted;
    }

    if (this.isAbbonatoPremium) {
      this.prorateCalculation(this.totaleDaPagareServizi, this.totaleDaPagareProdotti);
    } else {
      this.totaleDaPagare = this.totaleDaPagare - module.priceDiscounted;
      this.totaleDaPagareProrate = this.totaleDaPagare;
      this.totaleDaPagareProrate = parseFloat(this.totaleDaPagareProrate.toFixed(2));
    }
    this.totaleCoupon = this.totaleCoupon - (module.price - module.priceDiscounted);

    const listaIdModuloIndex = this.listaIdModulo.indexOf(module.moduleId, 0);
    if (listaIdModuloIndex > -1) {
      this.listaIdModulo.splice(listaIdModuloIndex, 1);
    }

    const listaIdTipoScontoIndex = this.listaIdTipoSconto.indexOf(module.discountTypeId, 0);
    if (listaIdTipoScontoIndex > -1) {
      this.listaIdTipoSconto.splice(listaIdTipoScontoIndex, 1);
    }

    const listaIdTipoAbbonamentoIndex = this.listaIdTipoAbbonamento.indexOf(
      module.subscriptionTypeId,
      0
    );
    if (listaIdTipoAbbonamentoIndex > -1) {
      this.listaIdTipoAbbonamento.splice(listaIdTipoAbbonamentoIndex, 1);
    }

    const listaIdPrezziIndex = this.listaPrezzi.indexOf(module.moduleId, 0);
    if (listaIdPrezziIndex > -1) {
      this.listaPrezzi.splice(listaIdPrezziIndex, 1);
    }

    if (module.product) {
      const listaProdottiIndex = this.listaProdotti.indexOf(module.moduleId, 0);
      if (listaProdottiIndex > -1) {
        this.listaProdotti.splice(listaProdottiIndex, 1);
      }
    }
  }

  loadExtrauser() {
    // attualmente il seller non gestisce abbonamenti di anagrafiche senza abbonamento
    // se si cerca cardiologo 1016241, la load non farà nulla

    this.sfNome.setValue('');
    this.sfCognome.setValue('');
    this.sfEmail.setValue('');
    this.sfPremium.setValue('');
    this.sfInizioAbbonamento.setValue('');
    this.sfFineAbbonamento.setValue('');
    this.tokenCodice = '';
    this.couponForm.controls.idTipoSconto.reset();
    this.submitLoadUserPremium.emit(this.sellerForm.value.sfIdAnagrafica);
  }


  async stripeHandleCardAction(payment: PaymentIntent) {
    // Your Stripe public key
    const stripe = await loadStripe(this.environmentService.stripePkKey);
    if (payment.status === 'requires_action') {
      stripe.confirmCardPayment(payment.client_secret).then((result) => {
        this.logService.info('HANDLE CARD ACTION: ', result);
        this.submitConfirmCardPayment.emit({
          status: result.paymentIntent.status,
          clientSecret: this.clientSecret,
          card: null, // non ho bisogno di inviare la carta perchè è già stata salvata, emetto solo per aggiornare il db lato server che farà logica sullo status
          paymentIntent: this.paymentIntent,
          stripeId: this.stripeId,
          fullname: this.user().nome + ' ' + this.user().cognome,
          idAnagrafica: this.user().idAnagrafica
        });
      })
    }
  }
  async stripeMethods() {
    // Your Stripe public key
    const stripe = await loadStripe(this.environmentService.stripePkKey);
    // const stripe = Stripe(this.environmentService.stripePkKey);

    // Create `card` element that will watch for updates
    // and display error messages
    const elements = stripe.elements();


    const card = elements.create('card', {
      iconStyle: 'solid',
      style: {
        base: {
          iconColor: '#003159',
          color: '#003159',
          fontWeight: 500,
          fontFamily: 'Montserrat, sans-serif',
          fontSize: '13px',
          fontSmoothing: 'antialiased',

          ':-webkit-autofill': {
            color: '#5a8eb9'
          },
          '::placeholder': {
            color: '#5a8eb9'
          }
        },
        invalid: {
          iconColor: '#f90b0b',
          color: '#f90b0b'
        }
      }
    });
    // Add an instance of the card UI component into the `card-element` <div>
    card.mount('#card-element');


    card.on('change', (event) => {
      const displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });

    // Listen for form submission, process the form with Stripe,
    // and get the
    const paymentForm = document.getElementById('payment-form');

    paymentForm.addEventListener('submit', (event) => {
      this.logService.info('SUBMIT EVENT: ', event);
      this.isPagare = !this.isPagare;
      this.isProcess = !this.isProcess;

      stripe.createToken(card).then((result) => {
        if (result.token) {
          const cardToken = result.token;

          this.submitConfirmCardPayment.emit({
            status: this.paymentStatus,
            clientSecret: this.clientSecret,
            card: cardToken,
            paymentIntent: this.paymentIntent,
            stripeId: this.stripeId,
            fullname: this.user().nome + ' ' + this.user().cognome,
            idAnagrafica: this.user().idAnagrafica
          });
        }
      });

      this.changeDetectorRef.detectChanges();
      event.preventDefault();
    });
  }
}
